const markdownSample = `# H1
## H2
### H3
#### H4
##### H5
###### H6

Bold **bold text**

Italic *italicized text*

Strike through ~~The world is flat.~~

Link [title](https://www.example.com)

### Image
![alt text](${window.origin}/images/logo-128.png)

### Emoji
:dog: :cat: :+1: :fish:

:no_entry_sign: :negative_squared_cross_mark: :recycle: :soon:

:strawberry: :peach: :tomato: :banana:

### Block quote
>This is a block quote example

### Ordered List
1. First item
2. Second item
3. Third item

### Unordered List
- First item
- Second item
- Third item

Code \`code\`

Horizontal Rule

---

### Table

| Branch  | Commit           |
| ------- | ---------------- |
| main    | 0123456789abcdef |
| staging | fedcba9876543210 |

### Fenced Code Block
\`\`\`
{
  "firstName": "John",
  "lastName": "Smith",
  "age": 25
}
\`\`\`

### Footnote

Here's a sentence with a footnote. [^1]

[^1]: This is the footnote.

### Task List
- [x] Write the press release
- [ ] Update the website
- [ ] Contact the media
`

export default markdownSample
